import React, { useState } from 'react'
import moment, { Moment } from 'moment'
import Button from 'Components/button'
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers'
import MomentUtils from '@date-io/moment'
import TimePicker, { ITime } from './time-picker'
moment.locale('zh-cn', {
  weekdays: ['日', '一', '二', '三', '四', '五', '六'],
  weekdaysShort: ['日', '一', '二', '三', '四', '五', '六'],
  weekdaysMin: ['日', '一', '二', '三', '四', '五', '六'],
  week: { dow: 1 },
})
moment.weekdays(true)

const calendar_icon = require('static/calendar@3x.png')

interface IProps {
  onCancel: () => void
  onConfirm: () => void
  value: Moment
  momentIsSelected: boolean
  onDateChange: (t: Moment | undefined) => void
  onTimeChange: (t: ITime) => void
}

class LocalizedUtils extends MomentUtils {
  getCalendarHeaderText(date: Moment) {
    return date.format('YYYY年M月')
  }
}

export default function DatetimeSelector(props: IProps) {
  const {
    onCancel,
    onConfirm,
    value,
    onTimeChange,
    onDateChange,
    momentIsSelected,
  } = props
  const [isOpen, setIsOpen] = useState(false)
  return (
    <>
      <div className="date-time-wrapper">
        <MuiPickersUtilsProvider
          libInstance={moment}
          utils={LocalizedUtils}
          locale="zh-cn"
        >
          <KeyboardDatePicker
            value={value || moment().add(1, 'days')}
            className="date-picker"
            onChange={m => {
              setIsOpen(false)
              onDateChange(m || undefined)
            }}
            inputVariant="outlined"
            variant="inline"
            disableToolbar={true}
            disablePast={true}
            allowKeyboardControl={false}
            format="YYYY-MM-DD"
            emptyLabel={moment().format('YYYY-MM-DD')}
            orientation="landscape"
            keyboardIcon={<img src={calendar_icon} className="calendar-icon" />}
            KeyboardButtonProps={{
              onFocus: e => {
                setIsOpen(true)
              },
            }}
            PopoverProps={{
              disableRestoreFocus: true,
              onClose: () => {
                setIsOpen(false)
              },
            }}
            InputProps={{
              onFocus: () => {
                setIsOpen(true)
              },
            }}
            open={isOpen}
          />
        </MuiPickersUtilsProvider>
        <TimePicker
          value={value}
          onChange={onTimeChange}
          className="time-picker"
          momentIsSelected={momentIsSelected}
        />
      </div>

      <div className="bottom-btn">
        <Button className="cancel-btn" type="default" onClick={onCancel}>
          清空
        </Button>
        <Button className="confirm-btn" type="new_primary" onClick={onConfirm}>
          确认
        </Button>
      </div>
      <style jsx>
        {`
          .date-time-wrapper {
            display: flex;
            padding: 16px 0;
            align-items: center;
          }
          .calendar-icon {
            width: 16px;
            height: 16px;
            object-fit: cover;
            object-position: center;
          }
          :global(.date-picker) {
            width: 209px;
            height: 36px;
          }
          :global(.date-picker > div) {
            border-radius: 2px;
          }
          :global(.date-picker input) {
            padding: 8px 16px;
            color: ${momentIsSelected ? '#1f2129' : '#979aa8'};
            font-size: 14px;
            font-weight: normal;
            font-family: PingFang SC;
            height: 36px;
            box-sizing: border-box;
          }
          :global(.MuiOutlinedInput-notchedOutline) {
            border-color: #c9cbd6;
          }
          :global(.MuiOutlinedInput-root.Mui-focused
              .MuiOutlinedInput-notchedOutline) {
            border-color: rgba(0, 0, 0, 0.87);
            border-width: 1px;
          }
          :global(.MuiPaper-root) {
            margin-left: 26px;
          }
          :global(.MuiPickersCalendarHeader-switchHeader) {
            margin: 0;
          }
          :global(.MuiTypography-root) {
            font-size: 14px;
          }
          :global(.MuiPickersCalendarHeader-daysHeader, .MuiPickersCalendar-week) {
            padding: 0 12px;
            justify-content: space-between;
          }
          :global(.MuiPickersCalendarHeader-dayLabel) {
            width: 26px;
            color: #1f2129;
          }
          :global(.MuiPickersBasePicker-pickerView) {
            max-height: 250px;
            min-height: 238px;
            min-width: 260px;
            max-width: 260px;
          }
          :global(.MuiPickersBasePicker-pickerView
              > .MuiPickersSlideTransition-transitionContainer) {
            min-height: 180px;
            margin-top: 8px;
          }
          :global(.MuiPickersBasePicker-pickerView.MuiPickersBasePicker-pickerViewLandscape) {
            padding: 0;
            overflow: hidden;
            justify-content: flex-start;
          }
          :global(.MuiPickersDay-day) {
            width: 26px;
            height: 25px;
            margin-bottom: 4px;
          }
          :global(.MuiPopover-root .MuiIconButton-root) {
            border-radius: 2px;
          }
          :global(.MuiPopover-root .MuiPickersDay-day:hover) {
            background-color: rgb(255, 204, 50, 0.4);
          }
          :global(.MuiPopover-root .MuiPickersDay-daySelected) {
            background-color: rgb(255, 204, 50);
            color: inherit;
          }
          :global(.time-picker) {
            margin-left: 8px;
          }
          .bottom-btn {
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
          }
          :global(.bottom-btn .cancel-btn) {
            font-weight: normal;
            border: 1px solid #c9cbd6;
          }

          :global(.bottom-btn .confirm-btn) {
            margin-left: 8px;
            font-weight: normal;
          }
        `}
      </style>
    </>
  )
}
